(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// ----------- Native javascript ----------- //
// legacy browser alert
var ua = navigator.userAgent;

if (ua.indexOf("MSIE 6.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 7.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 8.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 9.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 10.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else {}

var mySwiper = new Swiper('#mainvisual', {
  loop: true,
  speed: 2000,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 4000
  }
});
var mySwiper = new Swiper('#blog_post', {
  loop: false,
  speed: 2000,
  spaceBetween: 16,
  slidesPerView: 4,
  effect: 'slide',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    992: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 2
    },
    544: {
      slidesPerView: 1
    }
  }
}); // ----------- jQuery ---------------------- //

$(function () {
  // header effect
  var startPos = 0;
  var elem = $("#header_effect");
  var threshold = 300;
  $(window).on('scroll', function () {
    var currentPos = $(this).scrollTop();

    if (currentPos > startPos) {
      if ($(window).scrollTop() >= threshold) {
        elem.css({
          'transform': 'translateY(0)'
        });
      }
    } else {
      elem.css({
        'transform': 'translateY(-160px)'
      });
    }

    startPos = currentPos;
  }); // anchor scroll

  $('a[href*="#"].anchor-link').on('click', function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  }); // drawer nav

  $("#hmbg").on('click', function () {
    $("#overlay").fadeIn();
    $("#drawer").addClass('__open');
  });
  $("#close, #overlay").on('click', function () {
    $("#overlay").fadeOut();
    $("#drawer").removeClass('__open');
  }); // tabpanel

  $("#tab li").on('click', function () {
    var i = $("#tab li").index(this);
    $("#panel li").hide();
    $("#panel li").eq(i).show();
    $("#tab li").removeClass('__active');
    $(this).addClass('__active');
  }); // scroll top

  var thresholds = 200;
  var topBtn = $('#scrolltop');
  topBtn.css('bottom', '-100px');
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > thresholds) {
      topBtn.stop().animate({
        'bottom': '15px'
      }, 200);
    } else {
      topBtn.stop().animate({
        'bottom': '-100px'
      }, 200);
    }
  });
  topBtn.on('click', function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  }); //dropdown nav

  $(".dropdown_trigger").each(function () {
    $(this).hover(function () {
      $(this).children('.dropdown_nav').slideDown('fast');
    }, function () {
      $(this).children('.dropdown_nav').slideUp('fast');
    });
  });
});

},{}]},{},[1]);
